import stylesHome from "./Home.module.css"
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router";
import {Row} from "react-bootstrap";
import StepBar from "../../components/StepBar/StepBar";
import avatarCercaAssistente from "../../img/avatar/cerca_assistente.PNG";
import avatarSonoAssistente from "../../img/avatar/sono_assistente.PNG";
import avatarCercaAssistenteDisattivato from "../../img/avatar/carca_assistente_disattivato.PNG";
import avatarSonoAssistenteDisattivato from "../../img/avatar/sono_assistente_disattivato.PNG";
import iconContatta from "../../img/icons/contattaIcon.PNG"
import iconRicerca from "../../img/icons/iconRicerca.PNG"
import iconSeleziona from "../../img/icons/selezionaIcon.PNG"
import aggiornaHome from "../../img/icons/aggiorna_home.PNG"
import iscrivitiHome from "../../img/icons/iscriviti_home.PNG"
import verificaDocumentoHome from "../../img/icons/verifica_documento_home.PNG"
import Button from "../../components/Button/Button";
import Icon from "../../components/icon/Icon";
import Autocomplete from "../../components/Autocomplete/Autocomplete";
import Utils from "../../utils/Utils";
import auth from "../../../src/utils/AthnAuth";
import Spinner from "../../components/spinner/Spinner";
import ReportService from "../../services/ReportService";

function Home(props){

    const comuni = JSON.parse(sessionStorage.getItem("comuniCoordinate"))
    const province = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const [state, setState] = useState({home: {}});
    const [currentStep,setCurrentStep] = useState(null)
    const [codiceCurrentStep,setCodiceCurrentStep] = useState("01")
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    const [showSpinner,setShowSpinner] = useState(false)
    const [steps,setSteps] = useState([
        {nome: "Cerco un Assistente Familiare" ,codiceStep:"01",cliccabile:true, iconAttivo: avatarCercaAssistente, iconDisattivato: avatarCercaAssistenteDisattivato},
        {nome:"Sono un Assistente Familiare",codiceStep:"02",cliccabile:true, iconAttivo: avatarSonoAssistente , iconDisattivato: avatarSonoAssistenteDisattivato}
        ])

    const history = useHistory()

    useEffect(() => {
        if (history && history.location && history.location.steps && history.location.stepAttivo) {
            getDatiReport(history.location.stepAttivo)
        }else{
            getDatiReport(codiceCurrentStep)
        }
    }, [props])

    useEffect(() => {
        getDatiReport(codiceCurrentStep)
    }, [state.home && state.home.comuneRicerca, setState])

    function onClickButtonRicerca(){
        let jsonParam = {
            idReport: 1,
            provincia: province[state.home.comuneRicerca.codiceProvincia].descrizione
        }
        Utils.putReport(jsonParam)
        history.push({
            pathname: "/cercaAssistenteFamiliare",
            comune: state.home && state.home.comuneRicerca ? state.home.comuneRicerca : "",
            rerender: true
        })
    }

    function onChangeArrayComuni(id,value) {
        let newState = {...state}
        newState.home[id] = value ? value : ""
        setState(newState)
    }

    function onClickAccedi(){
        setShowSpinner(true)
        if(!sessioneUtente || sessioneUtente.tipoUtente === "03"){
            auth.login().then(r => {}).catch((error) => {
                console.log("Not signed in");
                console.error(`Errore: ${error}`);
            });
        }
        setShowSpinner(false)
    }

    function renderCercaAssistente(datiReport){
        return (
            <div className={stylesHome.marginInitialSezione}>
                <Row style={{textAlign: "center", justifyContent: "center"}}>
                    <div className={"col-3"}>
                        <p style={{fontSize: "19px", marginTop: "5px"}}>Cerco un Assistente Familiare a</p>
                    </div>
                    <div className={"col-3"}>
                        <Autocomplete
                            id={"comuneRicerca"}
                            onChange={onChangeArrayComuni}
                            placeholder={"Comune"}
                            suggestions={comuni}
                            value={state && state.home && state.home.comuneRicerca}
                        />
                    </div>
                    <div className={"col-1"}>
                        <Button
                            typeButton={"Blue"}
                            onClick={onClickButtonRicerca}
                            style={{width: "100%", height: "2.5rem", borderLeft: "none", fontSize: "16px"}}
                            text={"Cerca"}
                            disabled={state && state.home && state.home.comuneRicerca ? false : true}
                        />
                    </div>
                </Row>

                <div className={stylesHome.marginInitialSezione} style={{height: "250px", backgroundColor: "#f9f9f9"}}>
                    <div style={{textAlign: "center"}}><p style={{fontSize: "19px", fontWeight: "bold",paddingTop: "15px"}}>Come funziona per le famiglie</p></div>
                    <Row>
                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <Icon height={"80px"} width={"90px"} path={iconRicerca}/>
                            <p><strong>Ricerca</strong> <br/> Ricerca l'Assistente familiare nel Registro regionale utilizzando i diversi filtri.</p>
                        </div>

                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <Icon height={"90px"} width={"80px"} path={iconSeleziona}/>
                            <p><strong>Seleziona</strong> <br/> Seleziona il profilo più adatto alle tue esigenze.</p>
                        </div>

                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <Icon height={"80px"} width={"80px"} path={iconContatta}/>
                            <p><strong>Contatta</strong> <br/> Contatta direttamente l'Assistente Familiare <br/>per chiedere ulteriori informazioni.</p>
                        </div>
                    </Row>
                </div>

                <div className={stylesHome.marginSecondSezione} style={{height: "300px", backgroundColor: "#f0f0f0" }}>
                    <div style={{textAlign: "center"}}><p style={{fontSize: "25px", fontWeight: "bold",paddingTop: "15px"}}>I numeri del Registro</p></div>
                    <Row className={stylesHome.marginInitialSezione}>
                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <div className={stylesHome.circleReport}>
                                <div className={stylesHome.positionElementCircle}>
                                    <p style={{fontSize: "18px", fontWeight: "bold"}}>Sportelli <br/>attivi</p>
                                    <hr style={{border: "2px solid #1b7ea9", backgroundColor: "#1b7ea9", width: "100%"}}/>
                                    <p style={{fontSize: "22px", fontWeight: "bold", marginTop: "-5px"}}>{datiReport && datiReport.numSportelli?datiReport.numSportelli:0}</p>
                                </div>
                            </div>
                        </div>

                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <div className={stylesHome.circleReport}>
                                <div className={stylesHome.positionElementCircle}>
                                    <p style={{fontSize: "18px", fontWeight: "bold"}}>Referenti <br/>dei Comuni</p>
                                    <hr style={{border: "2px solid #1b7ea9", backgroundColor: "#1b7ea9", width: "100%"}}/>
                                    <p style={{fontSize: "22px", fontWeight: "bold", marginTop: "-5px"}}>{datiReport && datiReport.numUtenti?datiReport.numUtenti:0}</p>
                                </div>
                            </div>
                        </div>

                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <div className={stylesHome.circleReport}>
                                <div className={stylesHome.positionElementCircle}>
                                    <p style={{fontSize: "18px", fontWeight: "bold"}}>Assistenti <br/>Familiari</p>
                                    <hr style={{border: "2px solid #1b7ea9", backgroundColor: "#1b7ea9", width: "100%"}}/>
                                    <p style={{fontSize: "22px", fontWeight: "bold", marginTop: "-5px"}}>{datiReport && datiReport.numAssistenti?datiReport.numAssistenti:0}</p>
                                </div>
                            </div>
                        </div>
                    </Row>
                </div>

            </div>
        );

    }

    function mouseoverSpan() {
        document.getElementById("linkAccedi").style.color = "#004080";
    }

    function mouseoutSpan() {
        document.getElementById("linkAccedi").style.color = "#06c";
    }
    function renderSonoAssistente(datiReport){

        return (
            <div className={stylesHome.marginInitialSezione}>

                <div className={stylesHome.marginInitialSezione} style={{height: "300px", backgroundColor: "#f9f9f9"}}>
                    <div style={{textAlign: "center"}}><p style={{fontSize: "19px", fontWeight: "bold",paddingTop: "15px"}}>Come funziona per gli Assistenti Familiari</p></div>
                    <Row>
                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <Icon height={"80px"} width={"90px"} path={verificaDocumentoHome}/>
                            <p><strong>Verifica</strong> <br/> Verifica di avere tutti i requisiti <br/> per essere iscritto al Registro.</p>
                            <a href={"/faq"}>Clicca qui per vedere i requisiti richiesti.</a>
                        </div>

                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <Icon height={"80px"} width={"80px"} path={iscrivitiHome}/>
                            <p><strong>Iscriviti</strong> <br/> Iscriviti al Registro regionale recandoti <br/> allo Sportello dedicato più vicino.</p>
                            <a href={"/doveSiamo"}>Vedi la mappa degli Sportelli.</a>
                        </div>

                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <Icon height={"80px"} width={"80px"} path={aggiornaHome}/>
                            <p><strong>Aggiorna</strong> <br/> Aggiorna il tuo profilo per mantenere <br/> l'iscrizione al Registro ed essere contattato.</p>
                            <span style={{
                                color: "#06c",
                                fontSize: "18px",
                                textDecoration: "underline",
                                backgroundColor:"transparent",
                                pointerEvents: sessioneUtente && sessioneUtente.tipoUtente === "01"?"none":"",
                                cursor: sessioneUtente && sessioneUtente.tipoUtente === "01"?"default":"pointer"
                            }} onClick={onClickAccedi} onMouseOver={mouseoverSpan} id={"linkAccedi"} onMouseOut={mouseoutSpan}>Accedi al tuo profilo.</span>
                        </div>
                    </Row>
                </div>

                <div className={stylesHome.marginSecondSezione} style={{height: "300px", backgroundColor: "#f0f0f0" }}>
                    <div style={{textAlign: "center"}}><p style={{fontSize: "25px", fontWeight: "bold",paddingTop: "15px"}}>I numeri del Registro</p></div>
                    <Row className={stylesHome.marginInitialSezione}>
                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <div className={stylesHome.circleReport}>
                                <div className={stylesHome.positionElementCircle}>
                                    <p style={{fontSize: "18px", fontWeight: "bold"}}>Sportelli <br/>attivi</p>
                                    <hr style={{border: "2px solid #1b7ea9", backgroundColor: "#1b7ea9", width: "100%"}}/>
                                    <p style={{fontSize: "22px", fontWeight: "bold", marginTop: "-5px"}}>{datiReport && datiReport.numSportelli?datiReport.numSportelli:0}</p>
                                </div>
                            </div>
                        </div>

                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <div className={stylesHome.circleReport}>
                                <div className={stylesHome.positionElementCircle}>
                                    <p style={{fontSize: "18px", fontWeight: "bold"}}>Referenti <br/>dei Comuni</p>
                                    <hr style={{border: "2px solid #1b7ea9", backgroundColor: "#1b7ea9", width: "100%"}}/>
                                    <p style={{fontSize: "22px", fontWeight: "bold", marginTop: "-5px"}}>{datiReport && datiReport.numUtenti?datiReport.numUtenti:0}</p>
                                </div>
                            </div>
                        </div>

                        <div className={"col-4"} style={{textAlign: "center"}}>
                            <div className={stylesHome.circleReport}>
                                <div className={stylesHome.positionElementCircle}>
                                    <p style={{fontSize: "18px", fontWeight: "bold"}}>Assistenti <br/>Familiari</p>
                                    <hr style={{border: "2px solid #1b7ea9", backgroundColor: "#1b7ea9", width: "100%"}}/>
                                    <p style={{fontSize: "22px", fontWeight: "bold", marginTop: "-5px"}}>{datiReport && datiReport.numAssistenti?datiReport.numAssistenti:0}</p>
                                </div>
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        );

    }

    function renderStep(codiceStep,datiReport){
        setCodiceCurrentStep(codiceStep)
        switch (codiceStep) {
            case "01": {
                let newCurrentStep = (
                    renderCercaAssistente(datiReport)
                )
                setCurrentStep(newCurrentStep)
                break;
            }
            case "02": {
                let newCurrentStep = (
                    renderSonoAssistente(datiReport)
                )
                setCurrentStep(newCurrentStep)
                break;
            }
            default: {
                let newCurrentStep = (
                    renderCercaAssistente(datiReport)
                )
                setCurrentStep(newCurrentStep)
                break;
            }
        }
    }

    function getDatiReport(codiceCurrentStep){
        setShowSpinner(true)
        ReportService.getReport().then(res => {
            if(res.data){
                let datiReport =  {
                    numSportelli: res.data.grafico1.numSportelli,
                    numUtenti: res.data.infoAPMS.utentiTotali,
                    numAssistenti: res.data.grafico1.numAssistenti
                }
                renderStep(codiceCurrentStep,datiReport)
                setShowSpinner(false)
            }
        }).catch(reason => {
            console.log("Errore Operation GET Report: "+reason);
            setShowSpinner(false)
        })
    }

    return (

        <div className={stylesHome.marginInitial}>
            <Spinner show={showSpinner}/>
            <h4>Benvenuto nel Registro degli Assistenti Familiari</h4>
            <p>Il portale regionale che permette l'incontro tra domanda e offerta di cura e assistenza delle persone.</p>
            <p>Il servizio è gratuito, sia per le famiglie che per gli Assistenti Familiari</p>
            <StepBar steps={steps} stepAttivo={codiceCurrentStep} col={"col-6"} path={"/home"}/>
            {currentStep}
        </div>


    )


}
export default Home
